import { SharedState } from '$utils/sharedState.svelte';

class StateTransitionDirection extends SharedState<'left' | 'right' | null> {}

export const stateTransitionDirection = new StateTransitionDirection(null);
